<template>

    <select class="form-control" v-model="handler" @change="change">
        <option v-for="(value,key) in options" :key="key" :value="key">{{_lang(value)}}</option>
    </select>

</template>

<script>

export default {
  props: ['config', 'name', 'value'],
  data(){
      return {
          handler:'',
      }
  },
  computed:{
    options(){
        if(!this.config || !this.config.options) return {};
        if(Array.isArray(this.config.options)){
            var obj = {}
            for(var i in this.config.options){
                var value = this.config.options[i];
                obj[value] =value;
            }
            return obj;
        }
        return this.config.options;
    },
  },
  mounted(){
      this.handler = this.value;
  },
  methods:{
    change(){
        this.$emit('change',this.handler);
    },
  }

}
</script>
